import React, { useState, useContext } from 'react';
import './header.css';
import CTA from './CTA';
import HeaderSocial from './HeaderSocials';
import LanguageSwitcher from '../languageSwitcher/LanguageSwitcher';
import { useTranslation } from '../../contexts/TranslationContext';

const Header = () => {
  const { t } = useTranslation();
  const [isVideoClicked, setIsVideoClicked] = useState(false);

  const handleVideoClick = () => {
    setIsVideoClicked(true);
    setTimeout(() => setIsVideoClicked(false), 100);
  };

  return (
    <header>
      <LanguageSwitcher />
      <div className="container header__container">
        <h1>{"Tanguy Bruschi"}</h1>
        <h5 className="text-light">{t('Sound Designer')}</h5>
        <HeaderSocial />
        <section id="id_demoreel" className="demoreel_class">
          <div className="demoreel__container" style={{ position: 'relative' }}>
            <div 
              className="video-responsive" 
              onClick={handleVideoClick}
            >
              <iframe
                src="https://player.vimeo.com/video/1140690285"
                width="640"
                height="360"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Demo Reel"
              ></iframe>
            </div>
          </div>
          <CTA />
          <p className="scroll-hint">{t('header.scrollHint')}</p>
        </section>
        <div className="me">
          <section id="section-1">
            {/*<a href="#about" id="scroll-btn" aria-label={t('header.scroll')}>
              <span className="visually-hidden">{t('header.scroll')}</span>
            </a>*/}
          </section>
        </div>
      </div>
    </header>
  );
};

export default Header;
